/**
 * Device-local "recently viewed communities" history. Client-only concern (no
 * server table for view history), so it lives in localStorage — the same pattern
 * the community-view reactions use. Drives the "Jump Back In" rail on the My
 * Communities page. Newest first, deduped, capped.
 */
const KEY = 'winr:recent-communities';
const MAX = 12;

interface RecentEntry {
  id: string;
  at: number;
}

function read(): RecentEntry[] {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (e): e is RecentEntry =>
        Boolean(e) && typeof e.id === 'string' && typeof e.at === 'number',
    );
  } catch {
    return [];
  }
}

function write(entries: RecentEntry[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(entries.slice(0, MAX)));
  } catch {
    /* quota / private mode — recents are best-effort, never throw into the UI */
  }
}

/** Record a community open. Moves it to the front; dedupes by id. */
export function recordCommunityVisit(id: string): void {
  if (!id) return;
  write([{ id, at: Date.now() }, ...read().filter((e) => e.id !== id)]);
}

/** Recently-viewed community ids, most recent first. */
export function getRecentCommunityIds(): string[] {
  return read().map((e) => e.id);
}
